import React from "react";

function PollIcon({style={}}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...style}>
            <path
                d="M7.00537 8.33398C7.65186 8.33398 8.17725 8.85938 8.17725 9.50586V13.8281C8.17725 14.4746 7.65186 15 7.00537 15C6.35889 15 5.8335 14.4746 5.8335 13.8281V9.50586C5.8335 8.85742 6.35693 8.33398 7.00537 8.33398ZM10.1929 5C10.8394 5 11.3647 5.52539 11.3647 6.17188V13.8281C11.3647 14.4746 10.8394 15 10.1929 15C9.54639 15 9.021 14.4746 9.021 13.8281V6.17188C9.021 5.52539 9.54639 5 10.1929 5ZM13.3804 11.666C14.0269 11.666 14.5522 12.1914 14.5522 12.8379V13.8281C14.5522 14.4746 14.0269 15 13.3804 15C12.7339 15 12.2085 14.4746 12.2085 13.8281V12.8379C12.2085 12.1914 12.7339 11.666 13.3804 11.666Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default PollIcon;
